import { request } from '@/utils/request';

export interface LoginBody {
  timestamp: number;
  signature: string;
}

export const login = async (body: LoginBody) => {
  const data = await request
    .post<{ accessToken: string }>('admin/login', {
      json: body,
    })
    .json();

  return data.accessToken;
};

export enum MyConfigKey {
  ProgramLastSig = 'program_last_signature',
  CurrentLivestreamURL = 'current_livestream_url',
}

export const dashboard = async () => {
  return await request
    .get<{
      program: {
        signer: string;
        vault: {
          operator: string;
          withdrawer: string;
          bump: number;
          lamports: number;
          address: string;
        };
      };
      server: {
        ok: boolean;
      };
      db: {
        ok: boolean;
      };
      config: Record<MyConfigKey, any>;
    }>('admin/dashboard')
    .json();
};

export const getLivestreamCfg = async () => {
  const data = await request.get<Record<MyConfigKey, any>>('configs').json();

  return (data[MyConfigKey.CurrentLivestreamURL] ?? {}) as {
    url?: string;
    live?: boolean;
  };
};

export const updateConfig = async (key: MyConfigKey, value: any) => {
  const data = await request
    .post<Record<MyConfigKey, any>>(`admin/config/${key}`, { json: value })
    .json();

  return data;
};

export type MaybeFile = string | File;

export const uploadFiles = async (files: MaybeFile[]): Promise<MaybeFile[]> => {
  const promises = files.map(async (file) => {
    if (file instanceof File) {
      try {
        const body = new FormData();
        body.append('file', file);

        const { url } = await request
          .post<{ url: string }>('admin/file/upload', { body, timeout: false })
          .json();

        return url;
      } catch (error) {
        console.error('File upload error:', error);
      }
    }

    return file;
  });

  return await Promise.all(promises);
};
